const t = "{{currentTime}} out of {{duration}}", n = "Search result {{current}} of {{total}}", o = "No results found", s = "{{count}} result found", c = "{{count}} results found", e = 'Playing from $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) and $t(SECONDS, { "count": {{seconds}} }).', A = 'Playing from $t(MINUTES, { "count": {{minutes}} }) and $t(SECONDS, { "count": {{seconds}} }).', E = 'Playing from $t(SECONDS, { "count": {{seconds}} }).', T = "Error saving changes to transcript.", a = "Transcript line at {{time}}. Content is: {{text}}.", S = 'Transcript lines container. There $t(TRANSCRIPT_LINES, { "count": {{count}} }) inside this container. To navigate inside this container use down arrow key.', _ = "Saving changes...", r = "Changes saved to transcript.", N = "Update captions button is now available.", R = "Action", i = "Add annotation at {{time}}", O = "Add question at {{time}}", C = "Annotations", I = "Auto", u = "Auto ({{quality}})", P = "Back", U = "Captions", L = "Caption Language", l = "Manage Captions", d = "Delete {{language}}", p = "Font Size", D = "Caption Language: {{language}}", M = "{{language}} (automatic)", g = "Clear Search", m = "Close", Y = "Comments", G = "Continue", h = "Decrease Playback Speed", y = "Decrease Volume by {{percent}}%", V = "Down Arrow", H = "Close Transcript Editor", f = "Update Captions", b = "Error!", B = "Saving...", v = "Saved!", K = "Edit Transcript", k = "Text cannot be empty!", F = "Fullscreen", w = "{{count}} hour", Q = "{{count}} hours", W = "Increase Playback Speed", J = "Increase Volume by {{percent}}%", $ = "Invert Colours", x = "Jump to specific percentage (1-10%, 2-20%, etc)", q = "Jump to Start", z = "Actions for {{title}}", Z = "Keyboard shortcuts", X = "Language", j = "Left Arrow", tt = "Main menu", nt = "{{count}} minute", ot = "{{count}} minutes", st = "Mute", ct = "Muted", et = "Next Caption Language", At = "Next search result", Et = "Off", Tt = "On Top", at = "Open annotation at {{time}}", St = "Open completed quiz at {{time}}", _t = "Open quiz at {{time}}", rt = "Pause", Nt = "Play", Rt = "Playback Speed", it = "Playback Speed: {{speed}}x", Ot = "Previous Caption Language", Ct = "Previous search result", It = "Quality", ut = "Quality Menu", Pt = "Replay", Ut = "Reset Playback Speed", Lt = "Right Arrow", lt = "Search in transcript", dt = "{{count}} second", pt = "{{count}} seconds", Dt = "Seek backward: {{seconds}} seconds", Mt = "Seek forward: {{seconds}} seconds", gt = "Settings", mt = "Shortcut", Yt = "Media details and tools", Gt = "Space", ht = "Playback speed menu", yt = "Start Auto scroll", Vt = "Toggle captions", Ht = "Toggle Muted", ft = "Toggle Play/Pause", bt = "is {{count}} transcript line", Bt = "are {{count}} transcript lines", vt = "Loading transcript...", Kt = "We couldn't load the transcript.", kt = "Transcript Options", Ft = "Retry", wt = "Transcript unavailable", Qt = "Up Arrow", Wt = "Video Settings", Jt = "Volume", $t = "Volume: {{volume}}%", xt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: o,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: c,
  A11Y_TIMESTAMP_JUMP_HOURS: e,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: E,
  A11Y_TRANSCRIPT_ERROR: T,
  A11Y_TRANSCRIPT_LINE: a,
  A11Y_TRANSCRIPT_LINES: S,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: r,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: N,
  ACTION: R,
  ADD_ANNOTATION_AT: i,
  ADD_QUESTION_AT: O,
  ANNOTATIONS: C,
  AUTO: I,
  AUTO_QUALITY: u,
  BACK: P,
  CAPTIONS: U,
  CAPTIONS_LANGUAGE: L,
  CAPTIONS_MANAGE: l,
  CAPTION_DELETE: d,
  CAPTION_FONT_SIZE: p,
  CAPTION_LANGUAGE: D,
  CAPTION_LANGUAGE_AUTOMATIC: M,
  CLEAR_SEARCH: g,
  CLOSE: m,
  COMMENTS: Y,
  CONTINUE: G,
  DECREASE_PLAYBACK_SPEED: h,
  DECREASE_VOLUME: y,
  DOWN_ARROW: V,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: f,
  EDIT_ERROR: b,
  EDIT_SAVING: B,
  EDIT_SUCCESS: v,
  EDIT_TRANSCRIPT: K,
  EDIT_VALIDATION_ERROR: k,
  FULLSCREEN: F,
  HOURS: w,
  HOURS_other: Q,
  INCREASE_PLAYBACK_SPEED: W,
  INCREASE_VOLUME: J,
  INVERT_COLORS: $,
  JUMP_TO_PERCENTAGE: x,
  JUMP_TO_START: q,
  KEBAB_MENU: z,
  KEYBOARD_SHORTCUTS: Z,
  LANGUAGE: X,
  LEFT_ARROW: j,
  MAIN_MENU: tt,
  MINUTES: nt,
  MINUTES_other: ot,
  MUTE: st,
  MUTED: ct,
  NEXT_CAPTION_LANGUAGE: et,
  NEXT_HIT: At,
  OFF: Et,
  ON_TOP: Tt,
  OPEN_ANNOTATION_AT: at,
  OPEN_COMPLETED_QUIZ_AT: St,
  OPEN_QUIZ_AT: _t,
  PAUSE: rt,
  PLAY: Nt,
  PLAYBACK_SPEED: Rt,
  PLAYBACK_SPEED_MESSAGE: it,
  PREVIOUS_CAPTION_LANGUAGE: Ot,
  PREVIOUS_HIT: Ct,
  QUALITY: It,
  QUALITY_MENU: ut,
  REPLAY: Pt,
  RESET_PLAYBACK_SPEED: Ut,
  RIGHT_ARROW: Lt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: lt,
  SECONDS: dt,
  SECONDS_other: pt,
  SEEK_BACKWARD: Dt,
  SEEK_FORWARD: Mt,
  SETTINGS: gt,
  SHORTCUT: mt,
  SIDEBAR: Yt,
  SPACE: Gt,
  SPEED_MENU: ht,
  START_AUTOSCROLL: yt,
  TOGGLE_CAPTIONS: Vt,
  TOGGLE_MUTED: Ht,
  TOGGLE_PLAY_PAUSE: ft,
  TRANSCRIPT_LINES: bt,
  TRANSCRIPT_LINES_other: Bt,
  TRANSCRIPT_LOADING: vt,
  TRANSCRIPT_LOAD_ERROR: Kt,
  TRANSCRIPT_OPTIONS: kt,
  TRANSCRIPT_RETRY: Ft,
  TRANSCRIPT_UNAVAILABLE: wt,
  UP_ARROW: Qt,
  VIDEO_SETTINGS: Wt,
  VOLUME: Jt,
  VOLUME_VALUE: $t
};
export {
  t as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  o as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  c as A11Y_SEARCH_RESULTS_FOUND_other,
  e as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  E as A11Y_TIMESTAMP_JUMP_SECONDS,
  T as A11Y_TRANSCRIPT_ERROR,
  a as A11Y_TRANSCRIPT_LINE,
  S as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  r as A11Y_TRANSCRIPT_SUCCESS,
  N as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  R as ACTION,
  i as ADD_ANNOTATION_AT,
  O as ADD_QUESTION_AT,
  C as ANNOTATIONS,
  I as AUTO,
  u as AUTO_QUALITY,
  P as BACK,
  U as CAPTIONS,
  L as CAPTIONS_LANGUAGE,
  l as CAPTIONS_MANAGE,
  d as CAPTION_DELETE,
  p as CAPTION_FONT_SIZE,
  D as CAPTION_LANGUAGE,
  M as CAPTION_LANGUAGE_AUTOMATIC,
  g as CLEAR_SEARCH,
  m as CLOSE,
  Y as COMMENTS,
  G as CONTINUE,
  h as DECREASE_PLAYBACK_SPEED,
  y as DECREASE_VOLUME,
  V as DOWN_ARROW,
  H as EDIT_CLOSE,
  f as EDIT_CONFIRM,
  b as EDIT_ERROR,
  B as EDIT_SAVING,
  v as EDIT_SUCCESS,
  K as EDIT_TRANSCRIPT,
  k as EDIT_VALIDATION_ERROR,
  F as FULLSCREEN,
  w as HOURS,
  Q as HOURS_other,
  W as INCREASE_PLAYBACK_SPEED,
  J as INCREASE_VOLUME,
  $ as INVERT_COLORS,
  x as JUMP_TO_PERCENTAGE,
  q as JUMP_TO_START,
  z as KEBAB_MENU,
  Z as KEYBOARD_SHORTCUTS,
  X as LANGUAGE,
  j as LEFT_ARROW,
  tt as MAIN_MENU,
  nt as MINUTES,
  ot as MINUTES_other,
  st as MUTE,
  ct as MUTED,
  et as NEXT_CAPTION_LANGUAGE,
  At as NEXT_HIT,
  Et as OFF,
  Tt as ON_TOP,
  at as OPEN_ANNOTATION_AT,
  St as OPEN_COMPLETED_QUIZ_AT,
  _t as OPEN_QUIZ_AT,
  rt as PAUSE,
  Nt as PLAY,
  Rt as PLAYBACK_SPEED,
  it as PLAYBACK_SPEED_MESSAGE,
  Ot as PREVIOUS_CAPTION_LANGUAGE,
  Ct as PREVIOUS_HIT,
  It as QUALITY,
  ut as QUALITY_MENU,
  Pt as REPLAY,
  Ut as RESET_PLAYBACK_SPEED,
  Lt as RIGHT_ARROW,
  lt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  dt as SECONDS,
  pt as SECONDS_other,
  Dt as SEEK_BACKWARD,
  Mt as SEEK_FORWARD,
  gt as SETTINGS,
  mt as SHORTCUT,
  Yt as SIDEBAR,
  Gt as SPACE,
  ht as SPEED_MENU,
  yt as START_AUTOSCROLL,
  Vt as TOGGLE_CAPTIONS,
  Ht as TOGGLE_MUTED,
  ft as TOGGLE_PLAY_PAUSE,
  bt as TRANSCRIPT_LINES,
  Bt as TRANSCRIPT_LINES_other,
  vt as TRANSCRIPT_LOADING,
  Kt as TRANSCRIPT_LOAD_ERROR,
  kt as TRANSCRIPT_OPTIONS,
  Ft as TRANSCRIPT_RETRY,
  wt as TRANSCRIPT_UNAVAILABLE,
  Qt as UP_ARROW,
  Wt as VIDEO_SETTINGS,
  Jt as VOLUME,
  $t as VOLUME_VALUE,
  xt as default
};
